module.exports = __webpack_public_path__ + "static/media/stop-16.9c80afa9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-16.svg
// module id = 1383
// module chunks = 0